import NotificationIcon from '@atlaskit/icon/core/notification';
import * as React from 'react';

export function SvgBell() {
  return <NotificationIcon label="" testId="ads-refreshed-icon" />;
}
